import { AppDispatch } from '../../redux/store';
import { useDispatch } from 'react-redux';
import { AccessTimeRounded, ChatBubbleOutline, EmailOutlined, ForkLeftOutlined } from '@mui/icons-material';
import { addingConditionAutomationFlag, addingEmailAutomationFlag, addingSMSAutomationFlag, addingTimerAutomationFlag } from '../../redux/slices/automation';
import { Box, Button, ClickAwayListener, MenuItem, Paper, Popper, Typography } from '@mui/material';
import { EdgeProps, getBezierPath } from '@xyflow/react';
import React, { useState } from 'react';
import { settingSelectedEdge, settingSelectedNode } from '../../redux/slices/workflow';

const CustomEdge: React.FC<EdgeProps> = ({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [edgePath] = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });
  const [showPopup, setShowPopup] = useState<null | HTMLElement>(null);
  const showCondition = !id.includes('.');

  const setPopupHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    setShowPopup(e.currentTarget);
  };

  const addNodeHandler = (value: 'email' | 'phone' | 'timer' | 'condition') => {
    dispatch(settingSelectedEdge({ id, source, target, type: 'custom' }));
    dispatch(settingSelectedNode(null));
    if (value === 'email') {
      dispatch(addingEmailAutomationFlag(true));
    } else if (value === 'condition') {
      dispatch(addingConditionAutomationFlag(true));
    } else if (value === 'phone') {
      dispatch(addingSMSAutomationFlag(true));
    } else if (value === 'timer') {
      dispatch(addingTimerAutomationFlag(true));
    }
  };


  return (
    <>
      {/* Edge Line */}
      <path id={id} d={edgePath} stroke="#222" strokeWidth={2} fill="none" markerEnd={markerEnd} />

      {/* Add Node Button at Edge Center */}
      <foreignObject x={((sourceX + targetX) / 2) - 20} y={((sourceY + targetY) / 2) - 10} width="40" height="40">
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button
            variant="outlined"
            size="small"
            sx={{ fontSize: '10px', minWidth: '20px', padding: '2px 5px', backgroundColor: 'white' }}
            onClick={setPopupHandler}
          >
            +
          </Button>
          <Popper open={Boolean(showPopup)} anchorEl={showPopup} placement="bottom-start">
            <ClickAwayListener onClickAway={() => setShowPopup(null)}>
              <Paper sx={{ mt: 1, maxHeight: '200px', overflowY: 'auto', minWidth: '200px', backgroundColor: 'white', border: '1px solid #ddd' }}>
                <MenuItem onClick={() => addNodeHandler('email')}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <EmailOutlined />
                    <Typography variant="body2" fontWeight="bold">Add Mail</Typography>
                  </Box>
                </MenuItem>
                <MenuItem onClick={() => addNodeHandler('phone')}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <ChatBubbleOutline />
                    <Typography variant="body2" fontWeight="bold">Add SMS</Typography>
                  </Box>
                </MenuItem>
                <MenuItem onClick={() => addNodeHandler('timer')}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <AccessTimeRounded />
                    <Typography variant="body2" fontWeight="bold">Add Time Delay</Typography>
                  </Box>
                </MenuItem>
                {showCondition && <MenuItem onClick={() => addNodeHandler('condition')}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <ForkLeftOutlined />
                    <Typography variant="body2" fontWeight="bold">Add Condition</Typography>
                  </Box>
                </MenuItem>}
              </Paper>
            </ClickAwayListener>
          </Popper>
        </Box>
      </foreignObject>
    </>
  );
};

export default CustomEdge;
